import { ChangeEvent, JSX, useContext, useState } from "react";
import { MemberSetModel } from "@app/members";
import ResourceUpdateModel from "@app/resources/resourceUpdateModel";
import { FlyoutContext, FlyoutFooter } from "@app/shared/Flyouts";
import { QESButton } from "@app/shared/qes-standards/Button";
import { QESCheckbox } from "@app/shared/qes-standards/forms/Checkbox";
import { QESTextInput } from "@app/shared/qes-standards/forms/TextInput";

interface MemberSetEditResourceFlyoutProps {
  onSubmit: (resourceUpdateModel: ResourceUpdateModel) => void;
  memberSet: MemberSetModel;
}

const MemberSetEditResourceFlyout = (props: MemberSetEditResourceFlyoutProps): JSX.Element => {
  const [canSubmit, setCanSubmit] = useState(false);
  const [resourceName, setResourceName] = useState(props.memberSet.resource.name);
  const [resourceDescription, setResourceDescription] = useState(props.memberSet.resource.description);
  const [resourceIsPrivate, setResourceIsPrivate] = useState(props.memberSet.resource.isPrivate);
  const flyoutContext = useContext(FlyoutContext);

  const handleSubmit = () => {
    const updateModel = {
      description: resourceDescription,
      isPrivate: resourceIsPrivate,
      name: resourceName,
    };
    props.onSubmit(updateModel);
    flyoutContext.handleCloseFlyout();
  };

  const handleDescriptionChange = (event: ChangeEvent<HTMLInputElement>) => {
    setResourceDescription(event.target.value);
    setCanSubmit(true);
  };

  const handleNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setResourceName(event.target.value);
    setCanSubmit(true);
  };

  const handleIsPrivateChange = (event: ChangeEvent<HTMLInputElement>) => {
    setResourceIsPrivate(event.target.checked);
    setCanSubmit(true);
  };

  return (
    <>
      <div>
        <div>
          <div className="form-group row">
            <QESTextInput
              label="Name:"
              testId="member-set-edit-resource-flyout__name"
              containerClassName="col-4 offset-2 ps-0"
              value={resourceName}
              onChange={handleNameChange}
            />
          </div>

          <div className="form-group row">
            <QESTextInput
              label="Description:"
              testId="member-set-edit-resource-flyout__description"
              containerClassName="col-4 offset-2 ps-0"
              value={resourceDescription}
              onChange={handleDescriptionChange}
            />
          </div>
          <div className="form-group row">
            <div className="col-8 offset-2 ps-0">
              <QESCheckbox
                containerClassName="checkbox align-self-center"
                label="This is a Private Member Population (can be administered only by you)"
                id="isPrivate"
                testId="member-set-edit-resource-flyout__private"
                value="isPrivate"
                checked={resourceIsPrivate}
                onChange={handleIsPrivateChange}
              />
            </div>
          </div>
        </div>
      </div>
      <FlyoutFooter
        submitButton={<QESButton qesTestId="member-set-edit-resource-flyout_submit" disabled={!canSubmit} className="mb-3" onClick={handleSubmit}>Submit</QESButton>}
      />
    </>
  );
};

export default MemberSetEditResourceFlyout;
